<div
    #chapterBrowser
    class="chapter-browser"
    cdkDropList 
    cdkDropListOrientation="vertical" 
    (cdkDropListDropped)="handleDrop($event)">
    
    <div class="chapter-browser__scrim" *ngIf="!allChaptersLoaded">
        <app-spinner size="huge"></app-spinner>
    </div>

    <div 
        class="chapter-browser__item" 
        *ngFor="let chapter of (chapters$ | async)" cdkDrag>
        <app-chapter-card 
            [id]="'chapter-card__' + chapter.id"
            [chapter]="chapter" 
            [thumbnail]="(thumbnails$ | async)?.get(chapter.id)"
            [selected]="(selectedChapter$ | async)?.id === chapter.id"
            [canRemove]="(chapters$ | async).length > 1"
            (click)="handleClickChapter(chapter)"
            (remove)="handleRemove($event)"
            (duplicate)="handleDuplicate($event)"></app-chapter-card>
    </div>

    <button class="chapter-browser__add" app-button buttonType="outline" [matMenuTriggerFor]="importMenu">
        Add Chapter <fa-icon icon="angle-down"></fa-icon>
    </button>
</div>


<mat-menu #importMenu="matMenu">
    <button mat-menu-item (click)="handleDuplicateSelected()" style="min-width: 240px">
        Duplicate "{{ (selectedChapter$ | async)?.info.displayName || 'Chapter'}}"
    </button>

    <button mat-menu-item (click)="handleImportChapters()">
        Import Chapters...
    </button>
</mat-menu>